import http from "@/utils/request";
import {removeToken} from "@/utils/cookie";
import {Message} from "element-ui";

// 获取证书列表
export const getOrderList = (data) => {
    return http({
        url: "/shdc-edu/order/queryMyOrderList",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};

// 确认支付

export const confirmOrder = (data) => {
    return http({
        url: "/shdc-edu/order/offlinePaymentConfirm",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};
// 确认支付
export const getOrderDetailInfo = (data) => {
    return http({
        url: "/shdc-edu/order/getBankConfig",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};

export const getTrainingList = (data) => {
    return http({
        url: "/shdc-edu/order/getBankConfig",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};

export const getStudentList = (data) => {
    return http({
        url: "/shdc-edu/order/getBankConfig",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};

export const getCountTrainingList = (data) => {
    return http({
        url: "/shdc-edu/order/countTrainingByOrder",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};
export const getStudengtCountTrainingList = (data) => {
    return http({
        url: "/shdc-edu/order/countTrainingPersonCount",
        method: "post",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
};

/**
 * 修改订单下的人员登录手机号码
 * @returns {*}
 */
export const editOrderUserAccountPhone = (data) => {
    return http({
        url: "/shdc-edu/order/editUserPhone",
        method: "POST",
        data,
    }).then((res) => {
        if (res.code * 1 !== 200) {
            return Promise.reject(res);
        } else {
            return res.data;
        }
    });
}

// 导出培训班学习列表
export const exportTrainingData = "shdc-edu/order/exportTrainingCount";

/**
 * 下载excel文件
 * @param downloadUrl
 * @param data
 * @returns {*}
 */
// export const downloadExcel = (downloadUrl, data) => {
//     return http({
//         url: downloadUrl,
//         method: "get",
//         params: data,
//         responseType: "blob"
//     }).then(response => {
//         const type = response.type;
//         // 如果不是Blob，就转换成字符串
//         if (type.includes('application/json')) {
//             return response.text();
//         } else {
//             return Promise.resolve(response)
//         }
//     }).then(res => {
//         // 继续判断是否为token过期
//         if (res instanceof Blob) {
//             return res;
//         } else {
//             console.log("token time out")
//             return Promise.reject(res);
//         }
//     });
// }

/**
 * 带token下载Excel文件
 * @param downloadUrl   请求的url
 * @param fileName  下载下去保存的文件名称带后缀
 * @param data  带入的参数
 */
export function downloadExcelFile(downloadUrl, fileName, data = {}) {
    http({
        url: downloadUrl,
        method: "get",
        params: data,
        responseType: "blob"
    }).then(response => {
        const type = response.type;
        // 如果不是Blob，就转换成字符串
        if (type.includes('application/json')) {
            return response.text();
        } else {
            return Promise.resolve(response)
        }
    }).then(response => {
        // 下载
        if (response instanceof Blob) {
            let eLink = document.createElement("a");
            eLink.download = fileName;
            eLink.style.display = "none";
            eLink.href = URL.createObjectURL(response);
            document.body.appendChild(eLink);
            eLink.click();
            document.body.removeChild(eLink);
            URL.revokeObjectURL(eLink.href);
        } else {
            // 判断是否token过期，否则就弹出提示
            const json = JSON.parse(response);

            console.log(`response.code = ${json.code}`)

            if (json.code !== 200) {
                if (json.code === 401) {
                    removeToken();
                    location.href = "/";
                } else {
                    Message({
                        message: json.message || "请求错误",
                        type: "error",
                        duration: 5 * 1000,
                    });
                }
            }
        }
    })
}

// 导出学员培训详情
export const exportstudentData = "shdc-edu/order/exportPersonCount";
